
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FiAlertCircle } from 'react-icons/fi'

const Failure = ({ show, close, message }) => {
    return (
        <Modal show={show} onHide={close}>
            <Modal.Header className="gap-2 border-none">
                <FiAlertCircle
                    color="#FEE4E2"
                    className="successIcon"
                    size={30}
                />
                <div>
                    <Modal.Title className="titletext">Rejected!</Modal.Title>
                    <p className="textsubtitle">
                        {message}
                    </p>
                </div>
            </Modal.Header>
            <Modal.Footer className='border-none'>
                <Button className="btnUndo" onClick={close}>
                    Undo
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default Failure
